import React, { useRef, useEffect, useState, useMemo } from 'react';
// @ts-ignore
import html2pdf from "html2pdf.js"
import { getExistedSchemesAplication } from '../../auth/services/privateapicalling';
import { useSelector } from 'react-redux';
import { PDFDocument } from "pdf-lib";

interface  APMCp1Props{
    existData:any,
    applicationId:any,
    pdfData:any
}
const SchemesDownload = ({existData , applicationId , pdfData}: APMCp1Props) => {
    const pdfRef = useRef<HTMLDivElement>(null);
    // const [existData, setExistData] = useState(null);
    const [transaction, setTransaction] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const token = useSelector((state:any)=>state.auth.token);
    // const applicationId = 1001755505993628
    const id = existData.schemeId;
const [formData, setFormData] = useState({
    purpose: "",
    estimateProjectCostAmount: null as any,
    percentOfProjCostEligible: "",
    share: "",
});
const [assistanceDetails, setAssistanceDetails] = useState([
  {
    dateField: "",
    scheme2: "",
    purpose2: "",
    sanctionedAmount: "",
    assistanceReceived: "",
    totalExpenditure: "",
    shortfall: "",
    workCompletionDetails:null as any,
    contributionRatio: "",
  }
]);
   const apmcName = existData?.annexureOne?.apmc?.data.find(data=>data.fieldName == "apmcName")?.value;
   const scheme =   existData?.scheme?.name;
   const allYards = [...existData?.subYard, ...existData?.mainYard];

// Extract unique purpose names

   const purpose = allYards
     .map(item => item.purpose)
     .filter((value, index, self) => self.indexOf(value) === index)
     .join(', ');  

useEffect(() => {
 
   if (existData) {
    const isAnnexureOnePointOne = existData?.annexureOnePointOne?.newData;
   

    if (isAnnexureOnePointOne) {
      // ✅ Case 1: newData present (direct object structure)
      const newData = isAnnexureOnePointOne.data || {};

      setFormData((prev) => ({
        ...prev,
        purpose: newData?.purpose || "",
        estimateProjectCostAmount: newData?.estimateProjectCostAmount || "",
        percentOfProjCostEligible: newData?.percentOfProjCostEligible || "",
        share: newData?.share || "",
      }));



     
    } else {
      // ✅ Case 2: old structure (array inside annexureOne/Three)
      setFormData((prev) => ({
        ...prev,
        purpose:
          existData?.annexureOne?.purposeOfAssistance?.data?.find(
            (d) => d.fieldName === "purpose"
          )?.value || "",
        estimateProjectCostAmount:
          existData?.annexureOne?.estimateProjectCost?.data?.find(
            (d) => d.fieldName === "estimateProjectCostAmount"
          )?.value || "",
        percentOfProjCostEligible:
          existData?.annexureOne?.percentOfProjCostEligible?.data?.find(
            (d) => d.fieldName === "percentOfProjCostEligible"
          )?.value || "",
      }));

     
    }
  }
   
    setAssistanceDetails(
       existData?.annexureThree?.hasAssistanceApproved?.data
         ? existData.annexureThree.hasAssistanceApproved.data
              .filter((item: any) => item.fieldName && item.fieldName.startsWith("details_"))
              .sort((a: any, b: any) => {
                const numA = parseInt(a.fieldName.split("_")[1], 10);
                const numB = parseInt(b.fieldName.split("_")[1], 10);
                return numA - numB;
              })
              .map((item: any) => ({
                dateField: item.value?.date || "",
                scheme2: item.value?.scheme || "",
                purpose2: item.value?.purpose || "",
                sanctionedAmount: item.value?.amount || "",
                assistanceReceived: item.value?.assistance || "",
                totalExpenditure: item.value?.expenditure || "",
                shortfall: item.value?.shortfall || "",
                workCompletionDetails: item.value?.completion || "",
                contributionRatio: item.value?.contribution || "",
              }))
            :  [
  {
    dateField: "",
    scheme2: "",
    purpose2: "",
    sanctionedAmount: "",
    assistanceReceived: "",
    totalExpenditure: "",
    shortfall: "",
    workCompletionDetails:"",
    contributionRatio: "",
  }
]
     );
}, [existData]);


    const pageBreakStyle = {
        pageBreakBefore: "always",
        breakBefore: "page"
    };
    // const assistanceDetails = existData?.annexureThree?.hasAssistanceApproved?.data || [];
      const totalSanctionedAmount = useMemo(() => {
        if (!assistanceDetails || !Array.isArray(assistanceDetails)) return 0;
        return assistanceDetails.reduce((sum: number, block: any) => {
          const raw = (block?.sanctionedAmount ?? "").toString().replace(/[^0-9.\-]/g, "");
          const n = parseFloat(raw);
          return sum + (isNaN(n) ? 0 : n);
        }, 0);
      }, [assistanceDetails]);
    
    //   const formattedTotalSanctioned = totalSanctionedAmount > 0 ? totalSanctionedAmount.toLocaleString('en-IN') : "";
const purposeinputFn = () => {
  const data =existData?.annexureOne?.estimateProjectCost?.data[1]?.value || [];
  
  return (
    <div className="space-y-2">
      {data?.map((item, index) => (
         <div key={item.id || index} className="border rounded p-3 bg-gray-50">
          <div className="mb-2">
            <span className="font-medium text-gray-700">Name: </span>
            <span>{item.name}</span>
          </div>
          <div>
            <span className="font-medium text-gray-700">Cost: </span>
            <span>₹{item.cost.toLocaleString()}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
const displayAllYards = () => {
  const mainYardData = existData?.mainYard || [];
  const subYardData = existData?.subYard || [];
  const allYards = [...mainYardData, ...subYardData];
  
  // Group purposes by yard name
  const groupedByYard = allYards.reduce((acc, item) => {
    if (!acc[item.yard]) {
      acc[item.yard] = [];
    }
    acc[item.yard].push(item.purpose);
    return acc;
  }, {});
  
 return (
  <div className="space-y-2">
    {Object.entries(groupedByYard).map(([yardName, purposes], index) => (
      <div key={index} className="border rounded text-sm">
        <div className="px-2 py-1.5 font-semibold" style={{backgroundColor:"#CCE3FF"}}>
          {yardName}
        </div>
        <div className="px-2 py-1 bg-white">
          {Array.isArray(purposes) && purposes.map((purpose, pIndex) => (
            <div key={pIndex} className="text-gray-700 py-0.5 pl-2">
              • {purpose}
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);
};
  const numberToWords = (numStr: string): string => {
  // Remove any commas and trim whitespace
  numStr = numStr.replace(/,/g, '').trim();
  
  // Validate input
  // if (!/^\d+$/.test(numStr)) {
  //   return "Invalid input: Please provide a valid number string";
  // }
  
  const num = parseInt(numStr);
  
  // Check if number is within range
  if (num > 50000000) {
    return "Number exceeds 5 crore limit";
  }
  
  if (num === 0) {
    return "Zero";
  }
  
  // Arrays for number words
  const ones: string[] = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const teens: string[] = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", 
                 "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens: string[] = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  
  // Helper function to convert numbers less than 100
  const convertTens = (n: number): string => {
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
  };
  
  // Helper function to convert numbers less than 1000
  const convertHundreds = (n: number): string => {
    if (n < 100) return convertTens(n);
    return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + convertTens(n % 100) : "");
  };
  
  let result = "";
  
  // Crore (10,000,000)
  if (num >= 10000000) {
    const crore = Math.floor(num / 10000000);
    result += convertHundreds(crore) + " Crore ";
  }
  
  // Lakh (100,000)
  const remaining = num % 10000000;
  if (remaining >= 100000) {
    const lakh = Math.floor(remaining / 100000);
    result += convertTens(lakh) + " Lakh ";
  }
  
  // Thousand (1,000)
  const remaining2 = remaining % 100000;
  if (remaining2 >= 1000) {
    const thousand = Math.floor(remaining2 / 1000);
    result += convertTens(thousand) + " Thousand ";
  }
  
  // Hundred (100)
  const remaining3 = remaining2 % 1000;
  if (remaining3 >= 100) {
    const hundred = Math.floor(remaining3 / 100);
    result += ones[hundred] + " Hundred ";
  }
  
  // Last two digits
  const lastTwo = remaining3 % 100;
  if (lastTwo > 0) {
    result += convertTens(lastTwo);
  }
  
  return result.trim();
};
    const downloadPDF = () => {
        if (pdfRef.current) {
            // Clone without touching live DOM
            const clonedContent = pdfRef.current.cloneNode(true) as HTMLElement;

            // Remove flex layout from .page-wrapper in the clone
            const pageWrapper = clonedContent.querySelector(".page-wrapper") as HTMLElement | null;
            if (pageWrapper) {
                pageWrapper.classList.remove(
                    "d-flex",
                    "align-items-center", 
                    "justify-content-center",
                    "mt-3"
                );
                Object.assign(pageWrapper.style, {
                    display: "block",
                    width: "100%",
                    maxWidth: "none",
                    margin: "0",
                    padding: "0"
                });
            }

            // Generate landscape PDF
            html2pdf()
                .from(clonedContent)
                .set({
                    margin: 5,
                    filename: `APMC_Schemes_Download_${applicationId}.pdf`,
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
                })
                .save();
        }
    };

    
   const getJsxPdfBuffer = async (): Promise<ArrayBuffer | null> => {
    if (!pdfRef.current) return null;
 
    const clonedContent = pdfRef.current.cloneNode(true) as HTMLElement;
    clonedContent.style.display = "block";
 
    // html2pdf returns a promise chain, need .output("blob")
    const pdfBlob: Blob = await html2pdf()
      .from(clonedContent)
      .set({
        margin: 2,
        filename: "temp.pdf", // not downloaded
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      })
      .output("blob");
 
    return await pdfBlob.arrayBuffer();
  };
 
  const mergePdfs = async (
    appPdfBuffer: ArrayBuffer,
    docsPdfBuffer: ArrayBuffer,
    applicationId: string
  ) => {
    const mergedPdf = await PDFDocument.create();
 
    // Add JSX pages
    const appDoc = await PDFDocument.load(appPdfBuffer);
    const appPages = await mergedPdf.copyPages(appDoc, appDoc.getPageIndices());
    appPages.forEach((p) => mergedPdf.addPage(p));
 
    // Add backend docs pages
    const docsDoc = await PDFDocument.load(docsPdfBuffer);
    const docsPages = await mergedPdf.copyPages(docsDoc, docsDoc.getPageIndices());
    docsPages.forEach((p) => mergedPdf.addPage(p));
 
    // Save final
    const mergedBytes = await mergedPdf.save();
 
    // Trigger download
    const blob = new Blob([new Uint8Array(mergedBytes)], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Scheme_Application_${applicationId}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };
  const downloadMergedPdf = async () => {
    const appPdf = await getJsxPdfBuffer();        // from div
    const docsPdf = pdfData; // from backend
    //  const docsPdf = await pdfData
    if (appPdf && docsPdf) {
      await mergePdfs(appPdf, docsPdf, applicationId);
    }
  };
   
    return (
    <div>
        <div ref={pdfRef} style={{ display: "none", width: "100%", fontFamily: "Arial, sans-serif", padding: "10px" }}>
        <div className=" d-flex flex-column align-items-center justify-content-center mt-3">
            {/* Annexure 1 - New Page */}
            <div className='d-flex flex-column text-nightblue align-items-center justify-content-center w-100'>
                <h1 className='mb-3'>Annexure 1</h1>
                              <div className="w-100">
            <div className="row mb-4">
  <div className="col text-start mt-4">
    Application ID: {applicationId}
  </div>


</div>
</div>
                <div id='table' className='w-100 overflow-hidden bg-white border-secondary rounded mb-5' style={{ pageBreakInside: "auto"}}>
                <div id='head' className='d-flex w-100 rounded-top border border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                    <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                    <h4 className='col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                    <h4 className='col-5 p-2 justify-content-center d-flex align-items-center'>જવાબ(Response)</h4>
                    
                </div>
                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1  d-flex align-items-center justify-content-center'>01.</h4>
                    <div className='col-6 border-start border-end border-secondary  d-flex align-items-center justify-content-center p-2'>
                        <p className='p-2'>ખેતીવાડી ઉત્પન્ન બજાર સમિતિનું નામ અને સરનામું.(Name and address of the Agricultural Produce Market Committee).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
                        <h6 className="px-2">District - <span className=" text-info">{existData?.annexureOne?.apmc?.data[1]?.value}</span></h6>
                        <h6 className="px-2">Taluka - <span className=" text-info">{existData?.annexureOne?.apmc?.data[2]?.value}</span></h6>
                        <h6 className="px-2">APMC - <span className=" text-info">{existData?.annexureOne?.apmc?.data[0]?.value}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>02.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                    <p className='p-2'>
                        સ્થાપનાનું વર્ષ ( establishment)*
                    </p>
                    </div>

                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
                        <h6 className="px-2">Copy of Market Est Details - <span className=" text-info">{existData?.annexureOne?.copyOfMarketCommitteEstDet?.data[0]?.fileName}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>03.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>વર્ગ( Category )*</p>
                    </div>
                    <div  className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
                         <h6 className="px-2">Category - <span className=" text-info">{existData?.annexureOne?.certOfMarketCommitteCategory?.data[0]?.value}</span></h6>
                        <h6 className="px-2">Certificate of Market Committe - <span className=" text-info">{existData?.annexureOne?.certOfMarketCommitteCategory?.data[1]?.fileName}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>04.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>આ યોજના હેઠળ કયા કયા હેતુઓ માટે સહાય મેળવવા અરજી કરેલ છે ? (Under this scheme, for which purposes has assistance been requested?)*</p>
                    </div>
                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
                      
                        <h6 className="px-2"> {displayAllYards()}</h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>05.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>આ હેતુઓ માટેની પ્રોજેકટ કિંમત કેટલી છે?(પ્લાન અને એસ્ટીમેઇટ) અસલમાં બીડવા. Estimated project cost for these purposes (Layout plan and estimate to be submitted with original documents).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
                        <h6 className="px-2">{purposeinputFn()}</h6>
                        <h6 className="px-2">Plan Project Cost - <span className=" text-info">{existData?.annexureOne?.estimateProjectCost?.data[0]?.fileName}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>06.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>પ્રોજેકટ કિંમતના કેટલા ટકા મુજબ સહાય મળવાપાત્ર છે ?  (What percentage of the project cost is eligible for assistance? )*</p>
                    </div>
                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
                        <h6 className="px-2">Percentage - <span className=" text-info">{existData?.annexureOne?.percentOfProjCostEligible?.data[0]?.value}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>07.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>અરજીમાં દર્શાવેલ હેતુ માટે અગાઉ સહાય લીધેલ છે કે કેમ ?(Has assistance been availed previously for the purpose mentioned in the application?)*</p>
                    </div>
                    <div className='col-5 d-flex p-2 flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Is Existing Construction On Project Site - <span className=" text-info">{existData?.annexureOne?.isExistingConstructionOnProjSite?.data[0]?.value}</span></h6>
                        </div>
                    </div>
                </div>

                <div className='d-flex border border-secondary' style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>08.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>પ્લાન અને અંદાજો માન્ય પેનલ પરના એન્જીનીયરે તૈયાર કરેલા અને જે વર્ષે અરજી કરી હોય તે વર્ષના અથવા અદ્યતન એસ.ઓ.આર. મુજબના અસલમાં રજૂ કરેલ છે? (Are the plans and estimates prepared by an approved panel engineer and submitted in original as per the applicable or updated S.O.R. of the year of application?)*</p>
                    </div>
                    <div className='col-5 d-flex flex-column gap-2 align-items-start p-2 justify-content-center'>
                        <h6 className="px-2">Plan Estimate By Approved PE - <span className=" text-info">{existData?.annexureOne?.planEstimateByApprovedPE?.data[0]?.fileName}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary' style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>09.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>પ્લાન/એસ્ટીમેટમાં દર્શાવેલ સુચિત કામોનો સમાવેશ પ્લાનમાં થયેલ છે કે કેમ ? જે તે જગ્યા ઉપર અન્ય કોઇ બાંધકામ થયેલ છે કે કેમ ?તથા પ્લાનમાં દર્શાવેલ જગ્યા ઉપર અન્ય કોઇ બાંધકામ થયેલ છે કે કેમ ?તેની રૂબરૂ સ્થળ તપાસ કરી / કરાવી વિગતો આપવી.(Have the proposed works shown in the plan/estimate been included in the plan?Has any other construction been done at the concerned location?And has any other construction been carried out on the area shown in the plan?Provide details after on-site inspection has been done.)*</p>
                    </div>
                    <div className='col-5 d-flex flex-column gap-2 align-items-start p-2 justify-content-center'>
                        <h6 className="px-2">Estimate Plan Construction - <span className=" text-info">{existData?.annexureOne?.estimatePlanConstruction?.data[0]?.fileName}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary' style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>10.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>સાધનો કે ઓજારો ખરીદવાના હોય તો તેના અસલ ક્વોટેશન રજૂ કરેલ છે ?(If tools or equipment are to be purchased, have the original quotations been submitted?)*</p>
                    </div>
                    <div className='col-5 d-flex flex-column gap-2 align-items-start p-2 justify-content-center'>
                        <h6 className="px-2">Tools Equip Quotations - <span className=" text-info">{existData?.annexureOne?.toolsEquipQuotations?.data[0]?.fileName}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>11.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>અંદાજો જાહેર બાંધકામ ખાતાના માન્ય એસ.ઓ.આર. મુજબના છે તે અંગેનું સરકારશ્રીનું સંબંધિત ઈજનેરશ્રીનું પ્રમાણપત્ર સામેલ રાખેલ છે ?(Is the certificate from the concerned government engineer included, confirming that the estimates are as per the approved S.O.R. of the public works department?)*</p>
                    </div>
                    <div className='col-5 d-flex flex-column gap-2 align-items-start p-2 justify-content-center'>
                        <h6 className="px-2">Estimate Certified By Govt Engineer - <span className=" text-info">{existData?.annexureOne?.estimateCertifiedByGovtEngineer?.data[0]?.fileName}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary' style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>12.</h4>
                    <div className='col-6 p-2 border-start border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>નીચે મુજબની બાંહેધરીઓ / પ્રમાણપત્રો (Following undertakings/certificates to be submitted:)</p>
                    </div>
                    
                </div>

                    {/* Part 2 Fields */}
                    <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>01.</h4>
                            <p className='w-100 p-2'>બજાર સમિતિમાં બાંધકામ કરવા માટે સંબંધિત સક્ષમ સત્તાધિકારીની મેળવેલ મંજૂરીની નકલ બીડેલ છે ?અથવા સક્ષમ સત્તાધિકારીની મંજૂરી મેળવી બાંધકામ કરવામાં આવશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a copy of the approval from the competent authority for construction in the Market Committee been attached? Or has a written undertaking been submitted stating that approval will be obtained before commencing construction?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Permission From Authority - <span className=" text-info">{existData?.annexureTwo?.permissionFromAuthority?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>02.</h4>
                            <p className='w-100 p-2'>સહાયના અનુસંધાને કરેલ બાંધકામ અંગેનો વીમો લેવામાં આવશે, તેવી સંબંધિત બજાર સમિતિએ લેખિત બાંહેધરી રજૂ કરેલ છે? (Has the concerned Market Committee submitted a written undertaking that insurance will be taken for the construction done under the assistance?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Insurance Undertaking Post Construction - <span className=" text-info">{existData?.annexureTwo?.insuranceUndertakingPostConstruction?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>03.</h4>
                            <p className='w-100 p-2'>સહાય મેળવ્યા બાદ હિસાબોનું ઓડીટ સહકારી ખાતાના ઓડીટર મારફતે કરાવવામાં આવશે, તેવી સંબંધિત બજાર સમિતિએ લેખિત બાંહેધરી રજૂ કરેલ છે? (Has the Market Committee submitted a written undertaking that accounts will be audited by the Cooperative Department Auditor after receiving assistance?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Audit Undertaking After Assistance - <span className=" text-info">{existData?.annexureTwo?.auditUndertakingAfterAssistance?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}} >
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>04.</h4>
                            <p className='w-100 p-2'>આયોજનાની તમામ શરતોનું પાલન કરવામાં આવશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted that all terms and conditions of the scheme will be complied with?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Scheme Conditions Undertaking - <span className=" text-info">{existData?.annexureTwo?.schemeConditionsUndertaking?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>05.</h4>
                            <p className='w-100 p-2'>જે હેતુ માટે સહાયની માંગણી કરવામાં આવી છે તે હેતુ માટે બજાર સમિતિ ભવિષ્યમાં અન્ય સહાય આપતી નાણાંકીય સંસ્થા પાસેથી સહાયની રકમ નહીં મેળવે તેવી લેખિત બાંહેધરી સામેલ છે? તેની નકલ (Has a written undertaking been included that the Market Committee will not seek financial assistance for the same purpose from any other funding agency in the future? A copy of the same.)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Joint Account Assistance Undertaking - <span className=" text-info">{existData?.annexureTwo?.jointAccountAssistanceUndertaking?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}} >
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>06.</h4>
                            <p className='w-100 p-2'>નિયામકશ્રી, ખેત બજાર અને ગ્રામ્ય અર્થતંત્ર, ગાંધીનગર સુચવે તે પ્રકારના રજિસ્ટરો નિભાવવાના રહેશે અને જરૂર જણાય તેવી માહિતી જ્યારે માંગે ત્યારે પુરી પાડવાની રહેશે, તે અંગેની લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted stating that registers as suggested by the Director, Agricultural Market and Rural Economy, Gandhinagar will be maintained, and necessary information will be provided as and when required?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">No Prior Assistance Undertaking - <span className=" text-info">{existData?.annexureTwo?.noPriorAssistanceUndertaking?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>07.</h4>
                            <p className='w-100 p-2'>આ યોજનાની કોઇપણ શરતનો ભંગ થયેલ જણાય તો સહાયની રકમ વ્યાજ સહિત પરત લેવા સરકારશ્રી હકકદાર રહેશે, તે અંગેની લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted stating that in case of any violation of the scheme conditions, the Government shall be entitled to recover the assistance amount with interest?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Register Maintenance Undertaking - <span className=" text-info">{existData?.annexureTwo?.registerMaintenanceUndertaking?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>08.</h4>
                            <p className='w-100 p-2'>બજાર સમિતિએ વિકાસના કામ માટે સહાય મળ્યા બાદ બે વર્ષની અંદર કામ પૂરૂં કરવાનું રહેશે, તે અંગે તથા સહાયની રકમ વપરાશના પ્રમાણપત્ર માટે માન્ય પેનલ પરના એન્જીનીયરની સહી સાથે પ્રમાણપત્ર રજૂ કરવાનું રહેશે, તે અંગેની લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted that the development work will be completed within two years of receiving assistance, and that a certificate with the signature of a certified panel engineer will be submitted confirming the use of the grant?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Repayment On Violation Undertaking - <span className=" text-info">{existData?.annexureTwo?.repaymentOnViolationUndertaking?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary ' style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>09.</h4>
                            <p className='w-100 p-2'>મંજૂર થયેલ સહાયની રકમ બજાર સમિતિ અને જે તે જિલ્લાના નાયબ નિયામક ખેતબજાર અને ગ્રામ્ય અર્થતંત્ર તથા જિલ્લા રજિસ્ટ્રાર, સહકારી સંસ્થાઓના સંયુક્ત નામે રાષ્ટ્રીયકૃત બેંકમાં જમા કરાશે અને ઉપયોગના પ્રમાણમાં જિલ્લા રજિસ્ટ્રારશ્રીની મંજૂરીથી ઉપાડ કરવામાં આવશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted that the approved grant amount will be deposited in a nationalized bank jointly in the name of the Market Committee and the concerned Deputy Director and District Registrar, and that withdrawal will be made with the approval of the District Registrar as per the utilization?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Construction Completion Certificate - <span className=" text-info">{existData?.annexureTwo?.constructionCompletionCertificate?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>10.</h4>
                            <p className='w-100 p-2'>બજાર સમિતિ પાસે સરકારશ્રીનું કે કોઇ સંસ્થાનું મુદતવીતી લેણું બાકી નથી, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted stating that there is no overdue loan from the Government or any other institution pending against the Market Committee?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">No Outstanding Dues Undertaking - <span className=" text-info">{existData?.annexureTwo?.noOutstandingDuesUndertaking?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>11.</h4>
                            <p className='w-100 p-2'>સહાય અન્વયે બાંધકામ કરવાનું હોય તો ઉદ્યોગ અને ખાણ વિભાગના ઠરાવ ક્રમાંક SPO-102005-1407-ચ, તા. 22/11/06 તથા સંબંધિત જોગવાઈઓ અનુસાર "ઈ-ટેન્ડરીંગ" કરાશે અને તેની સૂચનાઓનું પાલન કરાશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (If construction is to be undertaken under the grant, has a written undertaking been submitted stating that "e-Tendering" will be done as per Industries and Mines Department Resolution No. SPO-102005-1407-Ch, dated 22/11/06 and relevant provisions, and that its instructions will be followed?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Construction Procurement E-Tendering - <span className=" text-info">{existData?.annexureTwo?.constructionProcurementETendering?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary' style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>12.</h4>
                            <p className='w-100 p-2'>મંજૂર થયેલ સહાયના અનુસંધાનમાં જો કોઈ વસ્તુ ખરીદવાની હોય, તો તે ખરીદી સરકારશ્રીના અમલમાં રહેલા નિયમો અને ધોરણો અનુસાર "ઈ-ટેન્ડરીંગ" દ્વારા કરાશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (If any item is to be purchased under the approved assistance, has a written undertaking been submitted stating that the purchase will be made through "e-Tendering" as per the prevailing rules and guidelines of the Government?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Goods Procurement E-Tendering - <span className=" text-info">{existData?.annexureTwo?.goodsProcurementETendering?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                    <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='d-flex gap-2 border-start border-end border-secondary '>
                            <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>13.</h4>
                            <p className='w-100 p-2'>જે હેતુ માટે સહાય મંજુર થશે તે હેતુ માટે જ ઉપયોગ કરવામાં આવશે તેવી બાંહેધરી. (A guarantee that the assistance will be used solely for the approved purpose.)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column d-flex align-items-start justify-content-center'>
                            <h6 className="px-2">Guarantee Assistance - <span className=" text-info">{existData?.annexureTwo?.guaranteeAssistance?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>

                {/* Part 3 Fields */}
                <div className='d-flex  border border-secondary border-top' style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1 justify-content-center d-flex align-items-center'>13.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary justify-content-center d-flex align-items-center '>
                            <p className='p-2'>જે હેતુ માટે સહાયની માંગણી કરવામાં આવી છે તે હેતુ માટે બજાર સમિતિની માલીકીની જમીન છે ? હા, તો તે અંગેના દસ્તાવેજોની નકલ સામેલ રાખેલ છે ?(Does the Market Committee own the land for the purpose for which assistance is requested? If yes, is a copy of the related documents attached?)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column align-items-start justify-content-center'>
                            <h6 className="px-2">Is Land Owned By Marketing Commitee - <span className=" text-info">{existData?.annexureThree?.isLandOwnedByMarketingCommitee?.data[0]?.fileName}</span></h6>
                        </div>
                </div>

                <div className='d-flex  border border-secondary 'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>14.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>આ યોજના હેઠળ અગાઉ સહાય મંજૂર થયેલ છે? ( Has assistance been approved earlier under this scheme? )*</p>
                    </div>
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Has Assistance Approved - <span className=" text-info">{existData?.annexureThree?.hasAssistanceApproved?.data[0]?.value}</span></h6>
                        </div>
                    </div>
                </div>
                
                <div>
                {existData?.annexureThree?.hasAssistanceApproved?.data
                    ?.slice(1, 6) // skip index 0, take max 6
                    .map((item, i) => (
                    <React.Fragment key={i}>
                        {/* Heading (14.1, 14.2, ...) */}
                        <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1 justify-content-center d-flex align-items-center '>
                            14.{i + 1}
                        </h4>
                        <div className='col-6 p-2 border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                            <p className='p-2'>
                            અગાઉની મંજુર સહાય અંગેની વિગતો (Details of Approved Assistance in Previous Years) *
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column align-items-center justify-content-center'>
                            <h6 className="px-2">
                            Assistance Approved - {i + 1}
                            </h6>
                        </div>
                        </div>

                        {/* 01. Date */}
                        <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='col-6 border-start border-end d-flex border-secondary'>
                            <h4 className='col-1 justify-content-center d-flex align-items-center border-end border-secondary h-100'>01.</h4>
                            <p className='p-2'>ક્યારે (Date)</p>
                        </div>
                        <div className='col-5 d-flex align-items-center justify-content-start'>
                            <h6 className="px-2">Date - <span className=" text-info">{item?.value?.date}</span></h6>
                        </div>
                        </div>

                        {/* 02. Scheme & Purpose */}
                        <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='col-6 border-start border-end d-flex border-secondary'>
                            <h4 className='col-1 justify-content-center d-flex align-items-center border-end border-secondary h-100'>02.</h4>
                            <p className='p-2'>યોજના, હેતુ (Scheme, Purpose)</p>
                        </div>
                        <div className='col-5 d-flex flex-column align-items-start justify-content-center gap-2 py-2'>
                            <h6 className="px-2">Scheme - <span className=" text-info">{item?.value?.scheme}</span></h6>
                            <h6 className="px-2">Purpose - <span className=" text-info">{item?.value?.purpose}</span></h6>
                        </div>
                        </div>

                        {/* 03. Total Project Cost */}
                        <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='col-6 border-start d-flex border-end border-secondary'>
                            <h4 className='col-1 justify-content-center d-flex align-items-center border-end border-secondary h-100'>03.</h4>
                            <p className='p-2'>કુલ પ્રોજેકટની રકમ (Total Project Cost)</p>
                        </div>
                        <div className='col-5 d-flex align-items-center justify-content-start'>
                            <h6 className="px-2">Sanctioned Amount - <span className=" text-info">{item?.value?.amount}</span></h6>
                        </div>
                        </div>

                        {/* 04. Combined Total */}
                        <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='col-6 border-start d-flex border-end border-secondary'>
                            <h4 className='col-1 justify-content-center d-flex align-items-center border-end border-secondary h-100'>04.</h4>
                            <p className='p-2'>
                            અગાઉ મેળવેલ સહાય અને હાલ સહાય મેળવવા કરેલ અરજીની પ્રોજેકટ કિંમતની રકમ મળી કુલ કેટલી થાય છે ? (Show the detailed information based on records. What is the combined total of the previously received assistance and the current project cost applied for?)*
                            </p>
                        </div>
                        <div className='col-5 d-flex align-items-center justify-content-start'>
                            <h6 className="px-2">Total Received Assistance - <span className=" text-info">{item?.value?.assistance}</span></h6>
                        </div>
                        </div>

                        {/* 05. Exceed 5 Cr */}
                      
                    </React.Fragment>
                    ))}
                      <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1'></h4>
                        <div className='col-6 border-start d-flex border-end border-secondary'>
                 
                            <p className='p-2'>રૂ. ૫ કરોડ કરતા વધુ થાય છે કે કેમ ?( Does it exceed ₹5 crore?)</p>
                        </div>
                       <div className='col-5 d-flex align-items-center justify-content-start'>
                            <h6 className="px-2">Exceeded 5 Cr - <span className=" text-info">{totalSanctionedAmount > 50000000?true:false}</span></h6>
                        </div>
                        </div>
                     
                </div>


                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>15.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            બજાર સમિતિ સામાન્ય વિસ્તાર કે આદિજાતિ વિસ્તારમાં આવેલી છે ? તે અંગેનું પ્રમાણપત્ર સામેલ રાખવું.(Is the Market Committee located in a general area or a tribal area? Attach the relevant certificate.)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Is Markting Committee Located In General - <span className=" text-info">{existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data[0]?.value}</span></h6>
                            <h6 className="px-2">Markting Committee Located In General - <span className=" text-info">{existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data[1]?.fileName}</span></h6>
                        </div>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>16.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            પ્રોજેકટ પૂર્ણ કરવા સહાય ઉપરાંતની રકમનો ખર્ચ કરવા માટે બજાર સમિતિ સક્ષમ છે ? તે ખર્ચ બજાર સમિતિ કેવી રીતે મેળવશે, તે અંગેની વિગતો રજૂ કરેલ છે ?(Is the Market Committee capable of bearing the cost beyond the assistance amount to complete the project? Have the details of how the committee will manage this expense been submitted?)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            
                            <h6 className="px-2">Markting Comm Financially Capable Of Expense - <span className=" text-info">{existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>17.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            છેલા ત્રણ વર્ષના આવક, ખર્ચ અને બચતની વિગત દર્શાવતું પત્રક રજૂ કરેલ છે?(Has a statement showing income, expenditure, and savings for the last three years been submitted?)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Inc Expenditure For Last 3 Yrs - <span className=" text-info">{existData?.annexureThree?.incExpenditureForLast3Yrs?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>18.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            છેલા ત્રણ વર્ષના આવક-જાવકના સરવૈયાની ઓડીટેડ પ્રમાણિત નકલ રજૂ કરેલ છે ?(Has a certified audited copy of the income-expenditure summary for the last three years been submitted?)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Audit Inc Expenditure For Last 3 Yrs - <span className=" text-info">{existData?.annexureThree?.auditIncExpenditureForLast3Yrs?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>19.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            બજાર સમિતિ પાસે ખેડૂતલક્ષી કઇ કઇ સુવિધાઓ હાલ ઉપલબ્ધ છે. તેનું પત્રક રજૂ કરેલ છે ?(Which farmer-oriented facilities are currently available with the Market Committee? Has the list been submitted?)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Existing Farmer Facilities - <span className=" text-info">{existData?.annexureThree?.existingFarmerFacilities?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>20.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            છેલા પાંચ વર્ષમાં નિયંત્રણમાં લીધેલ જણસીઓની માર્કેટ શેષ ફીની વિગત દર્શાવતું પત્રક તથા આગામી પાંચ વર્ષમાં માર્કેટ શેષ ફીની થનાર આવકની વિગત દર્શાવતું પત્રક રજૂ કરેલ છે ?(Has a statement been submitted showing the market cess income from controlled commodities over the past five years and the projected income from market cess for the next five years?)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Market Cess Income 5 Yrs Last - <span className=" text-info">{existData?.annexureThree?.marketCessIncome5YrsLast?.data[0]?.fileName}</span></h6>
                            <h6 className="px-2">Market Cess Income 5 Yrs Next - <span className=" text-info">{existData?.annexureThree?.marketCessIncome5YrsLast?.data[1]?.fileName}</span></h6>
                        </div>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>21.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            આ યોજના હેઠળ સહાય લેવા માટે બજાર સમિતિની મળેલ સામાન્ય સભાના ઠરાવની નકલ.(Copy of the Market Committee's General Body resolution regarding availing assistance under this scheme.)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Availing Assistance - <span className=" text-info">{existData?.annexureThree?.availingAssistance?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>
                </div>

                {/* <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>22.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            નાયબ નિયામક ખેતબજાર અને ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં. નો સહાય મંજુર કરવા બાબતનો વિગતવાર અભિપ્રાય.(Detailed opinion of the Deputy Director, Agricultural Market and Rural Economy, and District Registrar, Co-op. Societies regarding the sanction of assistance.)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Sanction Assistance - <span className=" text-info">{existData?.annexureThree?.sanctionAssistance?.data[0]?.fileName}</span></h6>
                        </div>
                    </div>
                </div>

                <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>23.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            જેમણે સ્થળ તપાસ કરી છે તે પ્રતિનિધિનો હોદ્દો (designation of representative who has done inspected on-site)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Designation Representative - <span className=" text-info">{existData?.annexureThree?.designationRepresentative?.data[0]?.value}</span></h6>
                        </div>
                    </div>
                </div>

                <div className='d-flex border border-secondary rounded-bottom'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                    <h4 className='col-1 justify-content-center d-flex align-items-center '>24.</h4>
                    <div className='col-6 p-2  border-start border-end border-secondary justify-content-center d-flex align-items-center'>
                        <p className='p-2'>
                            જેમણે સ્થળ તપાસ કરી છે તે પ્રતિનિધિનું નામ (name of representative who has done inspected on-site)*
                        </p>

                    </div>
                
                    <div className='col-5 d-flex  flex-column align-items-start justify-content-center'>
                        <div className=''>
                            <h6 className="px-2">Name of Representative - <span className=" text-info">{existData?.annexureThree?.nameRepres?.data[0]?.value}</span></h6>
                        </div>
                    </div>
                </div> */}

                </div>
            </div>

            {/* Annexure 1.1 - New Page */}
            <div style={{ pageBreakBefore: "always", breakBefore: "page" }}>
                <div className='d-flex flex-column text-nightblue align-items-center justify-content-center w-100'>
                    <h1 className='mb-3'>Annexure 1.1</h1>
                    <div id='table11' className='w-100 overflow-hidden bg-white border-secondary rounded mb-5' style={{ pageBreakInside: "auto"}}>
                        
                        {/* Header */}
                        <div id='head11' className='d-flex w-100 rounded-top border border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                            <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                            <h4 className='col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                            <h4 className='col-5 p-2 justify-content-center d-flex align-items-center'>જવાબ(Response)</h4>
                        </div>

                <div className='d-flex border border-secondary'>
                    <h4 className='col-1  d-flex align-items-center justify-content-center'>01.</h4>
                    <div className='col-6 border-start border-end border-secondary  d-flex align-items-center justify-content-center p-2'>
                        <p className='p-2'>ખેતીવાડી ઉત્પન્ન બજાર સમિતિનું નામ અને સરનામું.(Name and address of the Agricultural Produce Market Committee).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
                        <h6 className="px-2">District - <span className=" text-info">{existData?.annexureOne?.apmc?.data[1]?.value}</span></h6>
                        <h6 className="px-2">Taluka - <span className=" text-info">{existData?.annexureOne?.apmc?.data[2]?.value}</span></h6>
                        <h6 className="px-2">APMC - <span className=" text-info">{existData?.annexureOne?.apmc?.data[0]?.value}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary '>
                    <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>02.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                    <p className='p-2'>
                        સ્થાપનાનું વર્ષ ( establishment)*
                    </p>
                    </div>

                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
                        <h6 className="px-2">Copy of Market Est Details - <span className=" text-info">{existData?.annexureOne?.copyOfMarketCommitteEstDet?.data[0]?.fileName}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary'>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>03.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>વર્ગ( Category )*</p>
                    </div>
                    <div  className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
    <h6 className="px-2">Category - <span className=" text-info">{existData?.annexureOne?.certOfMarketCommitteCategory?.data[0]?.value}</span></h6>
                        <h6 className="px-2">Certificate of Market Committe - <span className=" text-info">{existData?.annexureOne?.certOfMarketCommitteCategory?.data[1]?.fileName}</span></h6>
                    </div>
                </div>

                <div className='d-flex border border-secondary'>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>04.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>આ યોજના હેઠળ કયા કયા હેતુઓ માટે સહાય મેળવવા અરજી કરેલ છે ? (Under this scheme, for which purposes has assistance been requested?)*</p>
                    </div>
                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-start justify-content-center'>
                       
                        <h6 className="px-2">{displayAllYards()}</h6>
                    </div>
                </div>

                        {/* Row 05: સહાય મંજુરી બાબતેની વિગતો */}
                         <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>05.</h4>
                        <div className='col-11 p-2 border-start border-secondary d-flex align-items-center justify-content-center'>
                            <p className='p-2'>
                                સહાય મંજુરી બાબતેની વિગતો (Details Regarding Sanction of Assistance)
                            </p>
                        </div>
                    </div>


                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'></h4>
                        <div className='col-11 border-start border-secondary d-flex align-items-center justify-content-center'>
                            {/* <h4 className='col-1 p-2 border-end border-secondary h-100 d-flex align-items-center justify-content-center'>01.</h4> */}
                            <div className='col-12 p-2'>
                                <table className="table table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Purpose</th>
                                            <th>Cost</th>
                                            <th>Eligible Cost</th>
                                            <th>Remark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData?.estimateProjectCostAmount && Array.isArray(formData.estimateProjectCostAmount) && formData.estimateProjectCostAmount.length > 0 ? (
                                            formData.estimateProjectCostAmount.map((item: any, index: number) => {
                                                const percentage = parseFloat(formData?.percentOfProjCostEligible) || 0;
                                                const calculatedEligibleCost = (item.cost * percentage) / 100;
                                                
                                                // Use existing eligibleCost if available, otherwise use calculated value
                                                const eligibleCostValue = item.eligibleCost !== undefined && item.eligibleCost !== null && item.eligibleCost !== "" 
                                                    ? item.eligibleCost 
                                                    : calculatedEligibleCost.toFixed(2);
                                                
                                                // Use existing remark if available, otherwise empty string
                                                const remarkValue = item.remark !== undefined && item.remark !== null 
                                                    ? item.remark 
                                                    : "";
                                                
                                                return (
                                                    <tr key={item.id || index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.name || "-"}</td>
                                                        <td>{item.cost || "-"}</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                name={`eligibleCost_${index}`}
                                                                value={eligibleCostValue}
                                                              
                                                                min="0"
                                                                step="0.01"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name={`remark_${index}`}
                                                                value={remarkValue}
                                                               
                                                            
                                                                placeholder="Enter remark"
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={5} className="text-center">No data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                
                                {/* Total Eligible Cost */}
                                {formData?.estimateProjectCostAmount && formData.estimateProjectCostAmount.length > 0 && (
                                    <div className="d-flex justify-content-end mt-3 pe-3">
                                        <strong>
                                            Total Eligible Cost: ₹{" "}
                                            {formData.estimateProjectCostAmount.reduce((total: number, item: any) => {
                                                const percentage = parseFloat(formData?.percentOfProjCostEligible) || 0;
                                                const calculatedEligibleCost = (item.cost * percentage) / 100;
                                                const eligibleCost = item.eligibleCost !== undefined && item.eligibleCost !== null && item.eligibleCost !== "" 
                                                    ? item.eligibleCost 
                                                    : calculatedEligibleCost;
                                                return total + parseFloat(eligibleCost || 0);
                                            }, 0).toFixed(2)}
                                        </strong>
                                    </div>
                                )}
                                
                             
                            </div>
                        </div>
                    </div>
                    
                
    {/* Row 06: Government Assistance */}
            <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                <h4 className='col-1 d-flex align-items-center justify-content-center'>06.</h4>
                <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                    <p className='p-2'>બજાર સમિતિ સરકારશ્રીની સહાય સિવાય રકમ ક્યાંથી ઉભી કરશે. તેની વિગતો (અભિપ્રાય સાથે ) (From where will the Market Committee raise the remaining amount apart from the Government assistance? Details of the same (with opinion).)</p>
                </div>
                <div className='col-5 d-flex px-4 align-items-center justify-content-start'>
                    <h6>Government Assistance Details - <span className=" text-info">{existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data[0]?.fileName}</span></h6>
                </div>
            </div>
            {/* Row 07: District Registrar Certificate */}
            <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                <h4 className='col-1 d-flex align-items-center justify-content-center'>07.</h4>
                <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                    <p className='p-2'>બજાર સમિતિ સામાન્ય વિસ્તાર કે આદિજાતિ વિસ્તારમાં આવેલી છે ?તેવી વિગત સામેલ છે ? તેની નકલ જિલ્લા રજિસ્ટ્રારશ્રીનુ પ્રમાણપત્ર (Whether the Market Committee is located in a general or tribal area? (Certificate from District Registrar).)</p>
                </div>
                <div className='col-5 d-flex px-4 flex-column align-items-start justify-content-center gap-2'>
                    <h6>Is Certificate Available - <span className=" text-info">{existData?.annexureOne?.certOfMarketCommitteCategory?.data[1]?.fileName}</span></h6>
                  
                </div>
            </div>
            
            {/* Row 08: Construction Approval */}
            <div className='d-flex border-bottom border-secondary' style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>08.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <p className='p-2'>
                            બાંધકામની મંજુરી (૧) બાંધકામની મંજુરી કોના દ્વારા ક્યારે આપવામાં આવેલ છે. તેની વિગતો.(Building Permission: (1) Who granted the construction permission and when? Provide details.)
                            </p>
                        </div>
                        <div className='col-5 d-flex px-4 flex-column align-items-start justify-content-center gap-2'>
                    <h6>Building Permission - <span className=" text-info">{existData?.annexureTwo?.permissionFromAuthority?.data[0]?.fileName}</span></h6>
                  
                </div>
                    </div>
            <div className='d-flex border border-secondary'style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                  <h4 className='col-1 d-flex align-items-center justify-content-center'>09.</h4>
                        <div className='col-11 p-2 border-start border-secondary d-flex align-items-center '>
                            <p className='p-2'>
                               પ્લાન ( Plan)
                            </p>
                        </div>
            </div>
           <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'></h4>
                        <div className='col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <h4 className='col-1 p-2 border-end border-secondary h-100 d-flex align-items-center justify-content-center'>01.</h4>
                            <p className='p-2 col-11'>
                              પ્લાન / એસ્ટીમેન્ટમાં દર્શાવેલ સુચિત જગ્યા પર અન્ય કોઈ બાંધકામ થયેલ છે કે કેમ ?(Has any other construction been done on the proposed site shown in the plan/estimate?)
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                         <div className=' d-flex justify-content-start w-75 gap-2'>
                                <label className="d-flex align-items-center gap-1">
                                    <input
                                        type='radio'
                                        name='isOnsiteInspectionCertDistrictRegistrar'
                                        value="yes"
                                        checked={existData?.annexureOne?.isExistingConstructionOnProjSite?.data.find(data=>data?.fieldName==="isExistingConstructionOnProjSite")?.value === "yes"}
                                        // onChange={handleInputChange}
                                        disabled
                                    />
                                    Yes
                                </label>
                                <label className="d-flex align-items-center gap-1">
                                    <input
                                        type='radio'
                                        name='isOnsiteInspectionCertDistrictRegistrar'
                                        value="no"
                                        checked={existData?.annexureOne?.isExistingConstructionOnProjSite?.data.find(data=>data?.fieldName==="isExistingConstructionOnProjSite")?.value === "no"}
                                        // onChange={handleInputChange}
                                        disabled
                                    />
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'></h4>
                        <div className='col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <h4 className='col-1 p-2 border-end border-secondary h-100 d-flex align-items-center justify-content-center'>02.</h4>
                            <p className='p-2 col-11'>
                              દરખાસ્તમાં જે કામ રજુ થયેલ છે. તે કામ માટે અગાઉ સહાય લીધેલ છે કે કેમ ?(Has assistance been taken earlier for the work proposed in the current application?)
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                         <div className=' d-flex justify-content-start w-75 gap-2'>
                                <label className="d-flex align-items-center gap-1">
                                    <input
                                        type='radio'
                                        name='hasAssistanceApproved'
                                        value="yes"
                                        checked={existData?.annexureThree?.hasAssistanceApproved?.data.find(data=>data?.fieldName==="isApproved")?.value === "yes"}
                                        // onChange={handleInputChange}
                                        disabled
                                    />
                                    Yes
                                </label>
                                <label className="d-flex align-items-center gap-1">
                                    <input
                                        type='radio'
                                        name='hasAssistanceApproved'
                                        value="no"
                                        checked={existData?.annexureThree?.hasAssistanceApproved?.data.find(data=>data?.fieldName==="isApproved")?.value === "no"}
                                        // onChange={handleInputChange}
                                        disabled
                                    />
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
            {/* Row 09: Assistance Details Header */}
            <div className='d-flex border border-secondary' style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
                <h4 className='col-1 d-flex align-items-center justify-content-center'>10.</h4>
                <div className='col-11 p-2 border-start border-secondary d-flex align-items-start justify-content-start'>
                    <p className='p-2'>આ અગાઉ મેળવેલ સહાયની વિગતો. (Details of assistance received previously.)</p>
                </div>
            </div>

            
            {/* Dynamic Assistance Details */}
              {assistanceDetails.map((block, index) => (
                                  
                                  <React.Fragment key={index}>
                                      {/* Section Heading */}
                                      <div className="d-flex px-3 py-2 bg-light border-bottom border-secondary">
                                          <strong>
                                              {['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'][index]} Detail 
                                              {index === 0 && <span className="text-danger">*</span>}
                                          </strong>
                                      </div>
          
          
                                      {/* Scheme Field */}
                                      <div className="d-flex border-bottom border-secondary">
                                          <h4 className="col-1"></h4>
                                          <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                              <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">01.</h4>
                                              <p className="col-10 p-2 d-flex align-items-center">યોજના, હેતુ (Scheme, Purpose) *</p>
                                          </div>
                                          <div className="col-5 d-flex flex-column gap-2 align-items-center justify-content-center">
                                              <input
                                                  type="text"
                                                  className="form-control w-75 m-2"
                                                  name="scheme"
                                                  disabled
                                                  value={block.scheme2 || ""}
                                                //   onChange={(e) => handleAssistanceChange(index, "scheme", e.target.value)}
                                                  placeholder="Enter Scheme"
                                                  minLength={3}
                                                  maxLength={100}
                                              />
                                                 <input
                                                  type="text"
                                                  className="form-control w-75 m-2"
                                                  name="scheme"
                                                  value={block.purpose2 || ""}
                                                //   onChange={(e) => handleAssistanceChange(index, "scheme", e.target.value)}
                                                  placeholder="Enter Scheme"
                                                  minLength={3}
                                                  disabled
                                                  maxLength={100}
                                              />
                                           
                                          </div>
                                      </div>
                   <div className="d-flex border-bottom border-secondary">
                                          <h4 className="col-1"></h4>
                                <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                  <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">02.</h4>
                                  <p className="col-10 p-2 d-flex align-items-center">કુલ પ્રોજેકટની રકમ (Total Project Cost)*</p>
                                </div>
                                <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                  <input
                                      type="number"
                                      className="form-control w-75 m-2"
                                      name="amount"
                                      value={block.assistanceReceived || ""}
                                    //   onChange={(e) => handleAssistanceChange(index, "amount", e.target.value)}
                                      placeholder="Enter Amount"
                                      disabled
                                      min="0"
                                      step="0.01"
                                      />
                              
                              </div>
                            </div>
                                      {/* Amount Field */}
                                      <div className="d-flex border-bottom border-secondary">
                                          <h4 className="col-1"></h4>
                                <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                  <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">03.</h4>
                                  <p className="col-10 p-2 d-flex align-items-center">મળેલ સહાય – (Assistance Received)*</p>
                                </div>
                                <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                  <input
                                      type="number"
                                      className="form-control w-75 m-2"
                                      name="amount"
                                      value={block?.sanctionedAmount || ""}
                                    //   onChange={(e) => handleAssistanceChange(index, "amount", e.target.value)}
                                      placeholder="Enter Amount"
                                      min="0"
                                      disabled
                                      step="0.01"
                                      />
                                
                              </div>
                            </div>
          
                              {/* Total Expenditure Field */}
                              <div className="d-flex border-bottom border-secondary">
                                  <h4 className="col-1"></h4>
                                  <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                      <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">04.</h4>
                                      <p className="col-10 p-2 d-flex align-items-center">કુલ ખર્ચ(Total Expenditure)*</p>
                                  </div>
                                  <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                    <input
                                      type="number"
                                      className="w-75 m-2 form-control"
                                      placeholder="Total Expenditure"
                                      value={block.totalExpenditure}
                                    //   onChange={(e) => handleAssistanceChange(index, "expenditure", e.target.value)}
                                      min="0"
                                      step="0.01"
                                      disabled
                                    />
                            
                                      </div>
                                  </div>
          
                              {/* Increase/Decrease Field */}
                              <div className="d-flex border-bottom border-secondary">
                                  <h4 className="col-1"></h4>
                                  <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                      <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">05.</h4>
                                      <p className="col-10 p-2 d-flex align-items-center">વધ / ધટ –( Excess / Shortfall)*</p>
                                  </div>
                                  <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                      <input
                                          type="number"
                                          className="w-75 m-2 form-control"
                                          placeholder="Increase / Decrease"
                                          value={block.shortfall}
                                        //   onChange={(e) => handleAssistanceChange(index, "shortfall", e.target.value)}
                                          step="0.01"
                                          disabled
                                      />
                                     
                                  </div>
                              </div>
          
                                      {/* Work Completion Details */}
                              <div className="d-flex border-bottom border-secondary">
                                  <h4 className="col-1"></h4>
                                  <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                      <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">06.</h4>
                                      <p className="col-10 p-2 d-flex align-items-center">કામ પૂર્ણ થયાની વિગતો (Details of Work Completion)*</p>
                                  </div>
                                  <div className="col-5 d-flex flex-column align-items-center my-2 justify-content-center">
                                 <h6 className="px-2"> <span className=" text-info">{block?.workCompletionDetails?.fileName}</span></h6>
                                  </div>
                                  </div>
                             
                                  </React.Fragment>
                              ))}
                </div>
            </div>
            </div>

            {/*Application -NewPage*/}
            <div style={{ pageBreakBefore: "always", breakBefore: "page" }}>
                <h1 className='mb-3'>Application For Scheme : </h1>
                  <div className="flex-grow-1"> 
            <div className="p-2 rounded">
              <p>
                આથી પ્રમાણિત કરવામાં આવે છે કે, ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
                <strong>{apmcName || '_______________'}</strong> ની વરહઃ<strong>&nbsp; {scheme} </strong>: બજાર સમિતિઓમાં આધુનિકરણ તેમજ પાયાની સગવડો ઉભી કરવા સહાય આપવાની યોજના હેઠળ
                <strong>&nbsp;{purpose || '______________________________'}</strong> ના હેતુઓ માટેની સગવડો ઉભી કરવાની દરખાસ્ત અત્રેની કચેરીને મળેલ છે.
              </p>
              <p>
                જેમાં અરજીમાં દર્શાવેલ તમામ કોલમોની વિગતની ચકાસણી કરતાં, તે સાચી અને ખરી માલુમ પડેલ છે અને તેની વિગતો અત્રેની કચેરીમાં રાખવામાં આવેલ છે.
              </p>
              <p>
                દરખાસ્તમાં દર્શાવેલ પ્રોજેકટ, બજાર સમિતિ
                <strong>  <input
                type="text"
                value={existData?.categoryName }
               
                className="mx-1 border-0 border-bottom border-secondary mb-3"
               
              /></strong> વર્ગ ધરાવતી હોઇ, પ્રોજેકટ કિંમત રૂ.
                <strong> <input
                type="text"
                value={ existData?.totalProjectCost}
           
                className="mx-1 border-0 border-bottom border-secondary mb-3"
             
              /></strong> ના
                <strong><input
                type="text"
                value={existData?.percentageApproval}
               
                className="mx-1 border-0 border-bottom border-secondary mb-3"
               
              /></strong> ટકા મુજબ રૂ.
                <strong> <input
                type="text"
                value={existData?.amount }
             
                className="mx-1 border-0 border-bottom border-secondary mb-3"
              
              /></strong> (અંકે રૂપિયા
                <strong>{numberToWords(existData?.amount ) || '______________________________________'}</strong>) પૂરા સહાય મંજૂર કરવાપાત્ર થાય છે અને તે મંજૂર કરવા માટે ભલામણ છે.
              </p>

              <hr />

              <p>
                (This is to certify that the Agricultural Produce Market Committee,
                <strong> {apmcName || '_______________'}</strong> has submitted a proposal to this office under the<strong>{scheme}</strong>  : A scheme to provide assistance for modernization and development of basic infrastructure in Market Committees, for the purpose of setting up facilities for <strong>{purpose}</strong>. Upon verification of all the columns mentioned in the application, the details are found to be true and accurate, and the same have been retained in this office. The project proposed in the application belongs to a Market Committee of
                <strong>   <input
                type="text"
                value={existData?.categoryName}
               
                className="mx-1 border-0 border-bottom border-secondary mb-3"
           
              /></strong> class. Based on the project cost of Rs.
                <strong>   <input
                type="text"
                value={existData?.totalProjectCost}
               
                className="mx-1000000000023 border-0 border-bottom border-secondary mb-3"
               
              /></strong>, assistance of Rs.
                <strong>   <input
                type="text"
                value={existData?.amount}
               
                className="mx-1 border-0 border-bottom border-secondary mb-3"
               
              /></strong> (in words:
                <strong> {numberToWords(existData?.amount) || '______________________________________'}</strong> rupees) at the rate of
                <strong> <input
                type="text"
                value={existData?.percentageApproval}
              
                className="mx-1 border-0 border-bottom border-secondary mb-3"
              
              /></strong>% is eligible for approval, and its approval is hereby recommended.)
              </p>

             
            </div>
          </div>
            </div>
            </div>
            </div>
            <div className='m-4' style={{ marginTop: "20px", textAlign: "center" }}>
                <button
                    onClick={downloadMergedPdf}
                    // disabled={loading}
                    style={{
                        padding: "10px 20px",
                        fontSize: "16px", 
                        cursor:  "pointer",
                        backgroundColor:  "#007bff",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                    }}
                >
                    { "Download Scheme"}
                </button>
            </div>
        </div>
    );
};

export default SchemesDownload